import {
  SET_RESET_PASSWORD_PROMPT,
  SET_PASSWORD_ERROR,
  SET_FORGOT_EMAIL_LOGIN
} from './constant'
import { MutationTree } from 'vuex'
import { AuthState } from './types'

export const mutations: MutationTree<AuthState> = {
  [SET_RESET_PASSWORD_PROMPT](state, resetPasswordPrompt: string) {
    state.resetPasswordPrompt = resetPasswordPrompt
  },
  [SET_PASSWORD_ERROR](state, passwordError: string) {
    state.passwordError = passwordError
  },
  [SET_FORGOT_EMAIL_LOGIN](state, email: string) {
    state.forgotEmailLogin = email
  }
}
